/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useShowError } from "~/components/Error/useShowError";
import { Employee } from "~/models";
import { useAxios } from "~/tools";

const useEmployees = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchEmployees = useCallback(async () => {
    try {
      const { data } = await Axios().get("/search/employees");
      const sort = data?.searchResults.sort((a: Employee, b: Employee) =>
        a.lastName.localeCompare(b.lastName)
      );
      setEmployees(sort);
    } catch (e) {
      showError(e.response);
    }
  }, [Axios, showError]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return {
    employees,
  };
};

export { useEmployees };
